import { trpc } from "@/lib/trpc";

const inputCls =
  "h-9 w-full rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground";
const labelCls = "mb-1 block text-xs font-medium text-zinc-600 dark:text-muted-foreground";

/**
 * Subcategoria do material — a química: zircônia, dissilicato, PMMA.
 *
 * A lista é a da base de mercado, curada pela plataforma; o laboratório escolhe, não cria. Química
 * que falta chega à base pela curadoria.
 *
 * Travado na edição pelo mesmo motivo do fabricante: trocar a química muda a identidade do
 * material, e a ficha montada em cima dele passaria a significar outra coisa.
 *
 * Atenção ao nome: no banco isto é `MaterialCategory`. Ver a nota no `schema.prisma` — os nomes
 * do código e da tela são trocados de propósito.
 */
export function MaterialQuimica({
  valor,
  onChange,
  desabilitado,
}: {
  valor: string;
  onChange: (materialCategoryId: string) => void;
  desabilitado?: boolean;
}) {
  const lista = trpc.prosthesis.catalog.materialCategories.useQuery().data ?? [];
  const foraDaLista = !!valor && lista.length > 0 && !lista.some((c) => c.id === valor);

  return (
    <div>
      <p className={labelCls}>Subcategoria</p>
      <select
        value={valor}
        onChange={(e) => onChange(e.target.value)}
        disabled={desabilitado}
        className={`${inputCls} disabled:opacity-60`}
      >
        <option value="">Selecione...</option>
        {foraDaLista && <option value={valor}>Subcategoria fora da base</option>}
        {lista.map((c) => (
          <option key={c.id} value={c.id}>
            {c.label}
          </option>
        ))}
      </select>
      {!desabilitado && (
        <p className="mt-1 text-[11px] text-zinc-500 dark:text-muted-foreground">
          Lista da base da plataforma. Falta alguma? Fale com o suporte.
        </p>
      )}
    </div>
  );
}
